module.exports = __webpack_public_path__ + "static/onebreath_logo-88397bd4616dfd314a2055d9ca3a1a11.png";